<template>
  <b-modal :active.sync="isActiveModal"
    has-modal-card
    :can-cancel="true"
    aria-role="dialog"
    :aria-modal="true" class="has-overflow">
      <div class="modal-card" style="width: 300px;">
        <ValidationObserver ref="observer">
          <section class="modal-card-body only-body">
            <b-field label="Busca un Caballo" expanded>
              <horse-selector :type="'autocomplete'" @select="horse = $event" :values="horses" :empty="empty" :autofocus="true"/>
            </b-field>
          </section>
        </ValidationObserver>
      </div>
    </b-modal>
</template>

<script>
import HorseSelector from '@/components/HorseSelector'
import HorseService from '@/services/HorseService'

export default {
  components: {
    HorseSelector
  },
  props: {
    active: {
      required: false,
      type: Boolean,
      default: false
    },
    horseId: {
      default: null
    }
  },
  created () {
    this.getHorses()
  },
  data () {
    return {
      isActiveModal: this.active,
      horse: null,
      horses: []
    }
  },
  methods: {
    async getHorses () {
      let params = {
        'include[0]': 'type.category'
      }
      let response = await HorseService.getHorses(params)
      this.horses = response.data.data
    },
    confirm () {
      this.$emit('confirm', this.horse)
      this.isActiveModal = false
    }
  },
  watch: {
    active () {
      if (this.active !== this.isActiveModal) {
        this.isActiveModal = this.active
      }
    },
    isActiveModal () {
      if (this.isActiveModal !== this.active) {
        this.$emit('update:active', this.isActiveModal)
      }
    },
    horse (value) {
      if (value) {
        this.confirm()
      }
    }
  },
  computed: {
    empty () {
      return this.horses.length === 0
    }
  }
}
</script>

<style scope>
  .modal-card-body.only-body{
    border-radius: 5px !important;
  }
</style>
